
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("aOxLa", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c79697f230b1b17c$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Italian (Italy)
var $c79697f230b1b17c$export$2e2bcd8739ae039 = {
    'ai-mate.chat-error-banner.description': 'La cronologia della chat viene salvata per un massimo di 30 giorni.',
    'ai-mate.chat-error-banner.title': 'Avvia una nuova chat',
    'ai-mate.chat-error.description': 'Prova a <btn>ricaricare la chat</btn>.',
    'ai-mate.chat-error.rate-limited-description': "Hai raggiunto il numero massimo di richieste. Riprova pi\xf9 tardi.",
    'ai-mate.chat-error.rate-limited-title': 'Troppe richieste',
    'ai-mate.chat-error.rovo-inactive-description': 'Sembra che Rovo non sia abilitato nel tuo sito. <link>Configura Rovo</link>',
    'ai-mate.chat-error.rovo-inactive-title': "Rovo \xe8 inattivo",
    'ai-mate.chat-error.title': "Si \xe8 verificato un problema",
    'ai-mate.main-chat.close-chat-button-label': 'Chiudi',
    'ai-mate.main-chat.maximize-chat-button-label': 'Schermo intero',
    'ai-mate.main-chat.minimize-chat-button-label': 'Ripristina la visualizzazione',
    'ai-mate.main-chat.new-chat-button-label': 'Nuova',
    'ai-mate.main-chat.new-chat-button-label-full-screen': 'Nuova chat',
    'conversation-assistant-button.label': 'Chat',
    'conversation-assistant-button.rovo-chat-label': 'Rovo Chat',
    'highlight-actions.rovo-chat-custom-prompt-submit-button.text': 'Invia',
    'highlight-actions.rovo-chat-custom-prompt.placeholder': 'Chiedi informazioni ad Atlassian Intelligence',
    'highlight-actions.rovo-chat-explain-option.text': 'Spiega',
    'highlight-actions.rovo-chat-explain-prompt': 'Spiega il concetto riformulandolo e aggiungendo ulteriori dettagli, ma usa un linguaggio molto semplice, frasi brevi ed esempi o definizioni di qualsiasi terminologia tecnica utilizzata nella formulazione originale.',
    'highlight-actions.rovo-chat-find-resources-option.text': 'Trova risorse',
    'highlight-actions.rovo-chat-find-resources-prompt': "Trova le risorse solo all'interno delle conoscenze dell'organizzazione che sostengono le dichiarazioni fatte.",
    'highlight-actions.rovo-chat-give-examples-option.text': 'Fornisci esempi',
    'highlight-actions.rovo-chat-give-examples-prompt': "Fornisci degli esempi tratti dalle risorse dell'organizzazione o di pubblico dominio. Se non sono disponibili risorse, prova a formulare un esempio metaforico che possa aiutare a capire meglio.",
    'highlight-actions.rovo-chat-give-feedback-option.text': 'Invia un feedback',
    'highlight-actions.rovo-chat-give-feedback-prompt': "Fornisci un feedback esaminando la formulazione. Introduci commenti sulla scelta delle parole, sulla grammatica e sulla punteggiatura. Mostra positivit\xe0 ed entusiasmo, ma indica sempre almeno un elemento da migliorare o cambiare.",
    'highlight-actions.rovo-chat-more-options.tooltip': 'Consigli sulla chat',
    'highlight-actions.rovo-chat-open-chat.tooltip': 'Apri chat',
    'highlight-actions.rovo-chat-summarize-option.text': 'Riepiloga',
    'highlight-actions.rovo-chat-summarize-prompt': 'Evidenzia i punti chiave che ne derivano. Concentrati sulle informazioni essenziali ed escludi i dettagli non necessari. Presenta una panoramica concisa in un solo paragrafo.',
    'highlight-actions.rovo-chat.button-text': 'Chat',
    'highlight-actions.rovo-chat.button-text-ask-in-chat': 'Chiedi in chat',
    'horizontal-scroll-container.scroll-left': 'Scorri a sinistra',
    'horizontal-scroll-container.scroll-right': 'Scorri a destra'
};

});


//# sourceMappingURL=it.1ebda216.js.map
